import React from "react";

// "ที่มา / อ้างอิง" + image credit at the end of an admin article (web page and edition sheet)
function ArticleCredit({ article }) {
  const sources = Array.isArray(article.sources) ? article.sources : [];
  if (!sources.length && !article.imageCredit) return null;
  return (
    <aside className="article-credit">
      {sources.length > 0 && (
        <>
          <h4>ที่มา / อ้างอิง</h4>
          <ol>
            {sources.map((s, i) => (
              <li key={i}>
                {s.url ? <a href={s.url} target="_blank" rel="noopener noreferrer nofollow">{s.name}</a> : s.name}
              </li>
            ))}
          </ol>
        </>
      )}
      {article.imageCredit && <p>เครดิตภาพ: {article.imageCredit}</p>}
    </aside>
  );
}

export default ArticleCredit;
